var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPound = function SvgPound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.354.876c1.768 0 3.477.374 5.127 1.121l-1.04 2.488c-1.476-.647-2.77-.97-3.882-.97-1.87 0-2.803.997-2.803 2.993v3.336h5.428v2.353H6.756v2.488c0 1.806-.655 2.854-1.996 3.609h10.336v2.83H.904v-2.666c.893-.273 1.554-.711 1.982-1.313.779-1.093.643-2.303.643-4.948H.959V9.844h2.57v-3.5c0-1.713.517-3.053 1.552-4.02C6.115 1.36 7.54.876 9.354.876z",
    fill: "#D64309"
  })));
};
export default SvgPound;